// Module
var code = "<div id=\"dms-notification\"></div>\n<div>\n    <div class=\"dms-menu-layoutwrapper\"></div>\n    <div class=\"dms-maincontent-wrapper\">\n        <div class=\"dms-layout-wrapper\"></div>\n    </div>\n</div>\n";
// Exports
export default code;